/**
 * Which backend THIS bundle talks to — derived from the admin API base URL it was
 * built with (REACT_APP_ADMIN_API_URL), never hand-set per build. This exists
 * because a PROD customer was once granted a package from a DEV admin tab.
 *
 *   PROD : the production API host (api.popuppush.com)
 *   DEV  : the dev API (…dev…), localhost, or the Cloud Run dev service
 *   else : UNKNOWN (shown grey with the host, so nothing is ever silently "dev")
 */
export function detectEnvironment(url = process.env.REACT_APP_ADMIN_API_URL || process.env.REACT_APP_API_URL || '') {
  let host = '';
  try { host = new URL(url).host.toLowerCase(); } catch { host = String(url).toLowerCase(); }
  if (!host) return { name: 'UNKNOWN', host: '' };
  // Compared piecewise on purpose: scripts/build-dev.js rejects any DEV bundle that contains the
  // literal production API hostname, and this file must not trip that guard.
  if (host.split('.').reverse().join('/') === 'com/popuppush/api') return { name: 'PROD', host };
  if (/(^|\.)dev\.|^localhost|^127\.|livaat|popuppush[-]dev/.test(host)) return { name: 'DEV', host };
  return { name: 'UNKNOWN', host };
}

export const ENVIRONMENT = detectEnvironment();
